import { ProductProfileDtoToEntity } from "src/app/features/ProductProfile/services/mappers/ProductProfileDtoToEntity";
import type { ProductProfileDto } from "src/app/features/ProductProfile/types/ProductProfileDto";
import type { ProductProfileEntity } from "src/app/features/ProductProfile/types/ProductProfileEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const ProductProfileTableDtoMapper = (
    input: Readonly<ResourcePageDto<ProductProfileDto>>,
): ResourcePageEntity<ProductProfileEntity> => {
    return {
        list: input.list ? input.list.map(ProductProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
